import React from "react";
import "./Dashboard.css";

const Dashboard = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '80vh',
      flexDirection: 'column',
      padding: '40px'
    }}>
      <div style={{
        textAlign: 'center',
        background: '#FFFFFF',
        border: '1px solid #DCDEE3',
        borderRadius: '10px',
        padding: '60px 80px',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)'
      }}>
        <h1 style={{
          fontSize: '48px',
          color: '#2E3C54',
          marginBottom: '20px',
          fontWeight: '600'
        }}>
          Dashboard Coming Soon
        </h1>
        <p style={{
          fontSize: '18px',
          color: '#6E7170',
          lineHeight: '1.6',
          maxWidth: '500px'
        }}>
          Analytics and insights will be available here once backend endpoints are implemented.
        </p>
        <p style={{
          fontSize: '14px',
          color: '#AAAAAA',
          marginTop: '30px'
        }}>
          In the meantime, use the navigation menu to access Orders, Inventory, and other features.
        </p>
      </div>
    </div>
  );
};

export default Dashboard;
